import { render, staticRenderFns } from "./mtbe2023Dashboard.vue?vue&type=template&id=00ffc50c&"
import script from "./mtbe2023Dashboard.vue?vue&type=script&lang=js&"
export * from "./mtbe2023Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports